import axios from 'axios';
import { apiServer, apiServerV2, noAuthAPIServer2, apiServerFormDataV2,noAuthAPIServerV2 } from './index';
import { devConfig } from '../config';
import { opsUrl } from '../utils/opsContext';
export function checkProfilePermission(payload) {
  console.log('checkProfilePermission', payload);
  return apiServerV2
    .post(`discover/profile-access/status`, JSON.stringify(payload), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error('Error in get Content Approval List:', error);
      throw error;
    });
}

export function unlockProfile(id, profile_type) {
  let url = `discover/${id}/unlock`;
  if (profile_type) {
    url += '?is_premium=true';
  }
  return apiServerV2
    .get(url)
    .then((response) => response.data)
    .catch((error) => {
      console.error('Error in get Content Approval List:', error);
      throw error;
    });
}

// `action` names the button/flow for the Daily Ops Stats source column.
export function fetchNewInfluencer(payload, action = 'Add creator by profile link') {
  return axios.post(
    opsUrl(`${devConfig.API_HOST}/api/v1/campaign/19/social_media/create/planner_profile/`, action),
    payload,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access')}`,
      },
    },
  );
}

export function fetchCuratedList(platform, category, search, page, rowsPerPage) {
  let url = `discover/curated-all?platform=${platform}`;
  if (category) {
    url += `&category=${category}`;
  }
  if (search) {
    url += `&search=${search}`;
  }
  if (page && rowsPerPage) {
    url += `&page=${page}&rows_per_page=${rowsPerPage}`;
  }
  return apiServer
    .get(url)
    .then((response) => response.data)
    .catch((error) => {
      console.error('Error in get Currated List:', error);
      throw error;
    });
}

export function fetchCuratedInfluencers(id, page,search) {
  return apiServer
    .get(`discover/curated-list?id=${id}&page=${page}&search=${search}`)
    .then((response) => {
      console.log('API Response:', response); // Log the entire response object
      return response.data;
    })
    .catch((error) => {
      console.error('Error in get Currated List:', error);
      throw error;
    });
}

export function getDiscoveryInfluencersDetails(id) {
  return apiServerV2.get(`/discover/${id}`).then((response) => {
    return response.data;
  });
}

export function getProfileUpdateStatus(iq_id) {
  return apiServerV2
    .get(`/discover/update-status?iq_id=${iq_id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error('Profile not Found: ', error);
      throw error;
    });
}

export function getPlans(brand_id) {
  return apiServer
    .get(`/discover/plan-list?brand_id=${brand_id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error('Plan not Found: ', error);
      throw error;
    });
}

export function addPlanProfiles(planId, data) {
  return apiServer.put(`/discover/plan/${planId}/add-iqprofile/`, JSON.stringify(data));
}

// Staff-only: detaches the given IQProfile ids from the Collab List. Never
// deletes the IQProfile rows themselves, only the plan's membership.
export function removePlanProfiles(planUUID, iqProfileIds) {
  return apiServer
    .post(
      `/discover/plan/remove-iqprofile/`,
      JSON.stringify({ uuid: planUUID, iq_profile_ids: iqProfileIds }),
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error('Error removing profiles from plan:', error);
      throw error;
    });
}

export function createPlan(data) {
  return apiServer
    .post(`/discover/plan/create/`, JSON.stringify(data), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => response)
    .catch((error) => {
      console.error('Error in Creating a Plan', error);
      throw error;
    });
}

export function fetchPlanList(brand_id, platform, search, page, rowsPerPage) {
  let url = `/discover/plan-list?brand_id=${brand_id}`;
  if (platform) {
    url += `&platform=${platform}`;
  }
  if (search) {
    url += `&search=${search}`;
  }
  if (page && rowsPerPage) {
    url += `&page=${page}&rows_per_page=${rowsPerPage}`;
  }
  return apiServer
    .get(url)
    .then((response) => response.data)
    .catch((error) => {
      console.error('Error in get Plan List:', error);
      throw error;
    });
}

export function fetchPlanInfluencers(id, platform, page, sortBy, search = '') {
  console.log('search', search, platform);
  return noAuthAPIServer2
    .get(
      `discover/plan-influencer?uuid=${id}&platform=${platform}&sort-by=${sortBy}&page=${page}&search=${search}`,
    )
    .then((response) => {
      console.log('API Response:', response);
      return response.data;
    })
    .catch((error) => {
      console.error('Error in get Plan List:', error);
      throw error;
    });
}

// Both bulk-link and CSV import can fail with a 402 when the user does not
// have enough credits to unlock the new/locked profiles the import would
// touch (see estimate_import_cost / PlanImportAPI.post on the backend).
// Callers rely on the rejected error carrying `error.response.data` (the
// `{error, message, ...estimate}` body) and `error.response.status` so they
// can tell a credit shortfall apart from any other failure.
export const addCollabProfileLinks = async (uuid, instaLinks = [], ytLinks = []) => {
  try {
    const payload = {
      uuid: uuid,
      is_csv: false,
      insta_links: instaLinks,
      yt_links: ytLinks,
    };
    const response = await apiServerV2.post(
      'discover/import-colab-profiles',
      JSON.stringify(payload),
    );
    return response;
  } catch (error) {
    console.error('Error uploading links:', error.response?.data || error.message);
    throw error;
  }
};

export const uploadCsvFile = async (uuid, csvFile) => {
  try {
    const formData = new FormData();
    formData.append('uuid', uuid);
    formData.append('is_csv', true);
    formData.append('csv_file', csvFile);

    const response = await apiServerFormDataV2.post('discover/import-colab-profiles', formData);
    // Full response (not just .data) so callers can read response.status,
    // matching addCollabProfileLinks above.
    return response;
  } catch (error) {
    console.error('Error uploading CSV file:', error.response?.data || error.message);
    throw error;
  }
};

export function colabImportStatus(planUUID) {
  let url = `/discover/colab-import-status?plan_uuid=${planUUID}`;
  return noAuthAPIServerV2
    .get(url)
    .then((response) => response.data)
}

export function downloadStatus(planUUID) {
  // https://api-staging.influencer.in/api/v2/discover/colab-response-sheet?uuid=d363d604-389e-4f72-b446-ac6417359055
  let url = `/discover/colab-response-sheet?uuid=${planUUID}`;
  return (
    apiServerV2
      .get(url)
      // .then((response) => response.data)
      .catch((error) => {
        console.error('Error in getting status:', error);
        throw error;
      })
  );
}

export function fetchPostWiseBifurcation(
  iq_id,
  is_paid=false,
  organic_post_type = 'all',
  organic_post_count = 12,
  paid_post_type='all',
  paid_post_count=12,
  period = 'lifetime',
  is_all=false,
  all_post_type='all',
  all_post_count=12) {
    let url = `/discover/post-wise?iq_id=${iq_id}`;

  if (period) {
    url += `&period=${period}`;
  }
  if (is_all) {
    url += `&is_all=true`;
    if (all_post_type) {
      url += `&all_post_type=${all_post_type}`;
    }
    if (all_post_count) {
      url += `&all_post_count=${all_post_count}`;
    }
  } else if (is_paid) {
    url += `&is_paid=true`;
    if (paid_post_type) {
      url += `&paid_post_type=${paid_post_type}`;
    }
    if (paid_post_count) {
      url += `&paid_post_count=${paid_post_count}`;
    }
  } else {
    url += `&organic_post_type=${organic_post_type}&organic_post_count=${organic_post_count}`;
  }

  return apiServer
    .get(url)
    .then((response) => response.data)
    .catch((error) => {
      console.error('Error in fetching Post Wise Bifurcation:', error);
      throw error;
    });
}

export function brandAffinityPost (payload) {
  return apiServerV2
  .post(`/discover/brand-affinity-preview`, JSON.stringify(payload), {
    headers: {
      'Content-Type': 'application/json',
    },
  })
  .then((response) => {
    return response.data;
  })
  .catch((error) => {
    console.error('Brand Posts not Found: ', error);
    throw error;
  });
}
